import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetCalendarSyncForActivityModal as GetCalendarSyncForActivityModalQuery,
    GetCalendarSyncForActivityModal_loggedInUser_calendarSync as CalendarSync,
} from 'nutshell-graphql-types';

import GET_CALENDAR_SYNC_FOR_ACTIVITY_MODAL from '../queries/get-calendar-sync-for-activity-modal.graphql';

export const useGetCalendarSyncForActivityModal = (): {
    calendarSync: CalendarSync | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetCalendarSyncForActivityModalQuery,
        Record<any, any>
    >(GET_CALENDAR_SYNC_FOR_ACTIVITY_MODAL, {
        fetchPolicy: 'network-only',
    });

    const loggedInUser = data ? data.loggedInUser : null;

    const calendarSync = loggedInUser && loggedInUser.calendarSync;

    return {
        calendarSync,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
